import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';
import { CONTACT } from '@common/constants';

import { Locksmith } from '@modules/services/locksmith/Locksmith';

const TITLE = 'Locksmiths in London | Qeeper';
const DESC = `Locksmiths in London for lock repairs, replacements, and emergency services—because no one should have to break into their home!  ${CONTACT.PHONE}`;

const URL = 'https://www.qeeper.co.uk/services/locksmith';

const SEO_KEYWORDS =
  'locksmiths in london, locksmith services, local locksmiths';

const LocksmithPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <Locksmith />
    </>
  );
};

export default LocksmithPage;
